"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BROADCAST_SET_SERVER_TIME_DELTA = void 0;
var BROADCAST_SET_SERVER_TIME_DELTA = exports.BROADCAST_SET_SERVER_TIME_DELTA = 'BROADCAST_SET_SERVER_TIME_DELTA';